import qs from 'qs'

const sort = ['exhibitionEntry.dateStart:desc', 'exhibitionEntry.dateEnd:asc', 'sortKey:asc']

const populate = {
  ...queryFragmentExhibitionEntry,
  files: true
}

export const queryPressKitEntriesThumbnail = (options: QueryManyOptionsi18n) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 4
      },
      sort: sort,
      populate: {
        localizations: {
          populate: populate
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `press-kit-entries?${query}`
}
